export const PRICING_HEADING_CONSTANTS = {
  title: "Compute Pricing",
  organization_server: " Intel Based Dedicated CPU ",
  user_server: " AMD Based Dedicated CPU ",
};
